module.exports = __webpack_public_path__ + "img/emoji-nowords-240x240.48452ac1.png";